/**
* Left Right JS
* -----------------------------------------------------------------------------
*
* All the JS for the Left Right component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'left-right',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      gsap.registerPlugin( ScrollTrigger );
      $( '.left-right' ).each( function( key, val ) {
        const colorBlock = $( this ).find( '.color-block-inner' )[0];
        const imageBlock = $( this ).find( '.blurred' )[0];
        const height = $( this ).outerHeight();

        if ( !window.matchMedia( '(prefers-reduced-motion)' ).matches ) {
          if ( colorBlock ) {
            const tl = gsap.timeline( {
              scrollTrigger: {
                trigger: this,
                start: 'top 50%',
                end: 'bottom 50%',
                scrub: 0,
                // markers: true,
              },
            } );
            tl.to( colorBlock, {y: '15%', ease: 'linear'}, 0 );
          }

          if ( imageBlock ) {
            const tl = gsap.timeline( {
              scrollTrigger: {
                trigger: this,
                start: 'top 50%',
                end: 'bottom 50%',
                scrub: 0,
                // markers: true,
              },
            } );
            tl.to( imageBlock, {y: '-15%', ease: 'linear'}, 0 );
          }
        }
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'left-right', COMPONENT );
} )( app );
